export function fullNameFormat(firstName: string, lastName: string): string {
  return `${lastName || ''} ${firstName || ''}`.trim();
}
